<template>
  <b-modal
        scrollable
    id="add-files-acceptance-modal"
    ref="modal"
    header-class="headerModal"
    centered
    size="md"
    :title="$t('AddFiles')"
    hide-footer
    @hide="onCancel"
  >
    <AddFile
      ref="addFile1"
      :occasion="'Inventory'"
      :folder="'DeliveryManagementFolder'"
      :label-text="$t('AddFiles')"
      :file-data-type="'Scetch'"
      :file-name="createFileDataDto"
      :file-format="'fourthFormat'"
    />
    <div class="buttonsEverywhere">
      <b-button
        type="button"
        variant="none"
        class="buttonSubmit"

        @click="onSubmit"
      >
        {{ $t('Submit') }}
      </b-button>
      <b-button
        type="button"
        variant="danger"
        class="buttonCancel"
        @click="onCancel"
      >
        {{ $t('Cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddFile from '@/modals/AddFile.vue';


export default {
  components: {
    AddFile,
  },
  props: ['orderUnique'],
  data() {
    return {
      createFileDataDto: [],
    }
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {

  },
  methods: {
    ...mapActions([]),
    async onSubmit() {
      await this.$refs.addFile1.uploadFile();
      const fileObjects = this.createFileDataDto.map((filePath) => {
        return {
          deliveryManagementId: this.orderUnique.id,
          fileUrl: filePath,
        }
      });
      this.$emit('addFilesDeliveryModal', fileObjects);
      this.$refs.modal.hide()
      this.onReset()
    },
    onCancel() {
      this.$refs.modal.hide()
      this.onReset()
    },
    onReset() {
    },
  },
}
</script>

    <style lang="scss" scoped>
    .team_table td {
      padding: 16px 9px !important;
    }
    </style>
